import { render, staticRenderFns } from "./ProjectStampingPlaces.vue?vue&type=template&id=4c1a8dd5&scoped=true&"
import script from "./ProjectStampingPlaces.vue?vue&type=script&lang=js&"
export * from "./ProjectStampingPlaces.vue?vue&type=script&lang=js&"
import style0 from "./ProjectStampingPlaces.vue?vue&type=style&index=0&id=4c1a8dd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1a8dd5",
  null
  
)

export default component.exports